// TODO: vertical testing needs to be centralized.
const REGEX = /mach|better|think|globalcitizen/i;

const isVerticalVideo = ({ source }) => source?.name && REGEX.test(source.name);

export default isVerticalVideo;
